import React from "react";
import Nav from "../components/Nav";
import Header from "../components/Header";

const Home = () => {
  return (
    <div>
      <Nav />
      <Header />
    </div>
  );
};

export default Home;
